import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const sendEmailTemplate: (
  fetchContext: FetchContext,
  programId: number, 
  emailTemplateId: number,
  accessToken?: string,
) => Promise<void> = async (fetchContext, programId, emailTemplateId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs/${programId}/email-templates/${emailTemplateId}/send`,
  {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'send email template'));
